
const insert = (tab) => ({
    type: 'INSERT_TAB_ROUTER',
    tab
});

const remove = (tab) => ({
    type: 'REMOVE_TAB_ROUTER',
    tab
});

export default {
    insert,
    remove
}